/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ColDef} from 'ag-grid-community';

import {isEmpty} from '../../../helpers/generic-helpers';

@Component({
    selector: 'app-global-scenario-select-pop-up',
    templateUrl: './global-scenario-select-pop-up.component.html',
    styleUrls: ['./global-scenario-select-pop-up.component.scss'],
    standalone: false
})
export class GlobalScenarioSelectPopUpComponent {
  // Data
  memberScenarioType: number;
  filterNonGM: boolean;
  user: string;
  displayedMemberHeaders: ColDef[];
  confirmText = 'Confirm Selection';

  protected readonly isEmpty = isEmpty;

  titleText = 'Select Global/Member Scenarios';

  selectedGlobalScenario: any;
  selectedMemberScenarios: any[] = [];


  constructor(@Inject(MAT_DIALOG_DATA) protected readonly data: any,
              public dialogRef: MatDialogRef<GlobalScenarioSelectPopUpComponent>) {
    if (!isEmpty(data)) {
      this.user = data.user;
      this.memberScenarioType = data.memberScenarioType;
      this.filterNonGM = data.filterNonGM;
      this.displayedMemberHeaders = this.data.columnHeaders;
    }
  }

  /**
   * Sets the selected
   * @param event
   */
  onSelectEvent(event: any) {
    this.selectedGlobalScenario = event.globalScenario;
    this.selectedMemberScenarios = event.memberScenarios;
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return selected row.
   */
  onConfirm(): void {
    this.dialogRef.close({
      data: {
        globalScenario: this.selectedGlobalScenario,
        memberScenarios: this.selectedMemberScenarios
      }
    });
  }
}
